<script setup lang="ts">
    import AcademyTrainingsCarouselView from '~/storyblok/AcademyTrainingsCarousel/AcademyTrainingsCarouselView.vue';
    import type { RelatedTrainingsMode } from '~/types/academy/courseRelations';

    const {
        courseId,
        mode = 'same_catalog',
        headline = '',
        relatedCourseIds = []
    } = defineProps<{
        courseId: string;
        mode?: RelatedTrainingsMode;
        headline?: string;
        relatedCourseIds?: number[];
    }>();

    const {
        items: carouselItems,
        isInitialLoading,
        prettyError
    } = useAcademyRelatedTrainings(
        () => courseId,
        () => mode,
        () => relatedCourseIds
    );
</script>

<template>
    <AcademyTrainingsCarouselView
        v-if="isInitialLoading || carouselItems.length > 0"
        :headline="headline"
    >
        <template
            v-if="$slots.teaser"
            #teaser
        >
            <slot name="teaser" />
        </template>

        <AcademyTrainingsCarouselClientContent
            :pretty-error="prettyError"
            :items="carouselItems"
            :show-no-results="false"
            :no-results-message="''"
            :is-initial-loading="isInitialLoading"
        />

        <template
            v-if="$slots.link"
            #link
        >
            <slot name="link" />
        </template>
    </AcademyTrainingsCarouselView>
</template>
